import { Check, CalendarCheck } from "lucide-react";
import { computeTotals, formatGBP } from "@autopic/shared";
import { useSession } from "../../store/sessionStore";
import { formatLongDate } from "../dates";
import s from "../steps.module.css";

/** Step 9 — confirmation with the booking reference. */
export function ConfirmationStep() {
  const state = useSession();
  const config = state.config!;
  const reference = state.bookingReference;
  const branch =
    (state.branches.length ? state.branches : config.branches).find(
      (b) => b.id === state.branchId,
    ) ?? null;
  const totals = computeTotals(
    config.sandbox ? config.services : state.availableServices,
    state.selectedServiceIds,
  );

  return (
    <div className={s.confirm}>
      <span className={s.confirmTick} aria-hidden="true">
        <Check size={40} strokeWidth={2.4} />
      </span>
      <h2 className={s.confirmTitle}>{config.copy.confirmationTitle}</h2>

      {reference && (
        <div className={s.refCard}>
          <span className={s.refLabel}>Your booking reference</span>
          <span className={s.refValue}>{reference}</span>
        </div>
      )}

      <p className={s.confirmDetail}>
        {state.contact.name ? `${state.contact.name.split(" ")[0]}, ` : ""}
        your booking is confirmed
        {branch ? ` for ${branch.name}` : ""}
        {state.slot ? (
          <>
            {" "}
            on <strong>
              {formatLongDate(state.slot.start.slice(0, 10))}
            </strong>, {state.slot.label}
          </>
        ) : null}
        . Total {formatGBP(state.bookingTotalPrice ?? totals.totalPrice)},
        payable at the branch.
      </p>

      <div className={s.nextAvail} style={{ marginTop: 4 }}>
        <CalendarCheck size={16} /> Keep the reference above if you need to
        contact the garage about this booking.
      </div>
    </div>
  );
}
